export const getUserName = state => state.user.name;
